import { render, staticRenderFns } from "./ServiceListing.vue?vue&type=template&id=3559430b&scoped=true"
import script from "./ServiceListing.vue?vue&type=script&lang=js"
export * from "./ServiceListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559430b",
  null
  
)

export default component.exports